import { render, staticRenderFns } from "./modifyLogistics.vue?vue&type=template&id=65c41092&scoped=true"
import script from "./modifyLogistics.vue?vue&type=script&lang=js"
export * from "./modifyLogistics.vue?vue&type=script&lang=js"
import style0 from "./modifyLogistics.vue?vue&type=style&index=0&id=65c41092&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65c41092",
  null
  
)

export default component.exports